import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import { Button } from '@saatva-bits/pattern-library.components.button'
import { Badge } from '@saatva-bits/pattern-library.components.badge'
import { formatToCurrency } from '@/utils/format'
import PictureImgix from '@/components/PictureImgix'
import { toppers } from '@/config/globals'
import styles from './styles.module.scss'

const ProductTile = ({ product, onClick = () => {}, index }) => {
    const onClickHandler = () => onClick(product, index + 1)

    const productTileConfig = (
        <>
            <div className={styles.price}> {formatToCurrency(product.lowestPrice)} - {formatToCurrency(product.highestPrice)}</div>
            <Button onClick={onClickHandler} className={styles.button} data-selector='recommendedProducts_viewDetails'>
                View details
            </Button>
        </>
    )

    const containerClasses = classNames(styles.container)
    const badgeClasses = classNames(styles.badge)

    const FormattedName = product.subcategory === toppers.subcategory ? product.name.replace(toppers.mattressRegex, '') : product.name
    const { defaultImage } = product
    
    return (
        <div className={containerClasses}>
            <button onClick={onClickHandler} className={styles.thumbnailContainer}>
                <PictureImgix
                    folder={defaultImage.folder}
                    name={defaultImage.name}
                    alt={defaultImage.alt}
                    widths={{
                        mobile: 158,
                        tablet: 200,
                        desktop: 200
                    }}
                />
                {!!product.tag && <Badge text={product.tag} className={badgeClasses} />}
            </button>
            <button onClick={onClickHandler} className={styles.name}>
                {FormattedName}
            </button>
            {productTileConfig}
        </div>
    )
}

ProductTile.propTypes = {
    product: PropTypes.object.isRequired,
    onClick: PropTypes.func,
    index: PropTypes.number
}

export default ProductTile
